import React from "react";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import MethodologyImage from "@/images/methodology-hero.png";
import SummerBootcampImage from "@/images/summer-bootcamp-hero.svg";

const ProgramDetailHero = ({ programType }) => {
  const { t } = useTranslation();

  if (programType === "summer-bootcamp") {
    return (
      <div className="w-full bg-white">
        <div className="max-w-[98%] lg:max-w-[90%] mx-auto px-[15px] md:px-4 lg:px-0 py-[40px] md:pt-[80px] md:pb-[60px]">
          <div className="flex flex-col-reverse lg:flex-row gap-[30px] md:gap-[40px] lg:gap-[64px] items-center">
            <div className="basis-full lg:basis-1/2 flex flex-col gap-[18px] min-w-0">
              <h1 className="font-[500] leading-[125%] text-[28px] md:text-[50px] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]">
                <span dangerouslySetInnerHTML={{ __html: t("programs-page.program-detail-hero-title-summer-bootcamp") }} />
              </h1>
              <div className="text-[16px] md:text-[18px] leading-[165%] text-black font-[400] flex flex-col">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("programs-page.program-detail-hero-description-summer-bootcamp-sentence-1"),
                  }}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("programs-page.program-detail-hero-description-summer-bootcamp-sentence-2"),
                  }}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("programs-page.program-detail-hero-description-summer-bootcamp-sentence-3"),
                  }}
                  className="mt-[25px]"
                />
              </div>
            </div>
            <div className="basis-full lg:basis-1/2 flex items-center justify-center lg:justify-end w-full">
              <div className="relative w-full max-w-[640px] aspect-[552/566] rounded-[20px] overflow-hidden">
                <Image
                  src={SummerBootcampImage}
                  alt={t("programs-page.program-detail-hero-title-summer-bootcamp")}
                  fill
                  className="object-cover"
                  priority
                  sizes="(max-width: 1024px) 100vw, 50vw"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const programData = {
    "front-end": {
      titleKey: "programs-page.program-detail-hero-title-front-end",
      descriptionKey: "programs-page.program-detail-hero-description-front-end",
    },
    "back-end": {
      titleKey: "programs-page.program-detail-hero-title-back-end",
      descriptionKey: "programs-page.program-detail-hero-description-back-end",
    },
    "full-stack": {
      titleKey: "programs-page.program-detail-hero-title-full-stack",
      descriptionKey: "programs-page.program-detail-hero-description-full-stack",
    },
    "software-engineering": {
      titleKey: "programs-page.program-detail-hero-title-software-engineering",
      descriptionKey: "programs-page.program-detail-hero-description-software-engineering",
    },
    "summer-bootcamp": {
      titleKey: "programs-page.program-detail-hero-title-summer-bootcamp",
      descriptionKey: "programs-page.program-detail-hero-description-summer-bootcamp",
    },
  };

  const program = programData[programType] || programData["full-stack"];

  return (
    <div className="w-full bg-white">
      <div className="max-w-[98%] lg:max-w-[90%] mx-auto px-[15px] md:px-4 lg:px-0 py-[40px] md:pt-[100px] md:pb-[60px]">
        <div className="flex flex-col-reverse lg:flex-row gap-[30px] md:gap-[40px] lg:gap-[80px] items-center">
          <div className="basis-full lg:basis-1/2 flex flex-col gap-[12px] md:gap-[20px] min-w-0">
            <h1
              className="font-[500] leading-tight text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884] text-[clamp(32px,5vw,96px)]"
            >
              <span dangerouslySetInnerHTML={{ __html: t(program.titleKey) }} />
            </h1>

            <p className="text-[16px] lg:text-[18px] font-[400] leading-[160%] text-black break-keep">
              {t(program.descriptionKey)}
            </p>
          </div>
          <div className="basis-full lg:basis-1/2 flex items-center justify-center lg:justify-end w-full">
            <div className="relative w-full max-w-[600px] aspect-[4/3]">
              <Image
                src={MethodologyImage}
                alt="Program Detail Hero"
                fill
                className="object-contain"
                priority
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ProgramDetailHero;